import React, { Component, PropTypes } from 'react';
import './Edit.css';

class Edit extends Component {

  render() {
    return (
      <svg onClick={this.props.onClick} className="editIcon__wrap" xmlns="http://www.w3.org/2000/svg" viewBox="1102.556 2591.352 23.054 20.801">
        <title>{this.props.title}</title>
        <g id="Group_138" transform="translate(1102.518 2591.352)">
          <g id="Group_136" transform="translate(8.322 5.717)">
            <path id="Path_165" className="editIcon" d="M996.986,386.764a.654.654,0,0,0,0-.924l-.85-.85a.653.653,0,0,0-.924,0l-.915.915,1.771,1.771Z" transform="translate(-987.812 -384.8)"/>
            <path id="Path_166" className="editIcon" d="M558.49,503.517l-.89,2.66,2.661-.888,5.016-5.017-1.771-1.771Z" transform="translate(-557.6 -496.811)"/>
          </g>
          <g id="Group_137" transform="translate(0.038)">
            <path id="Path_167" className="editIcon" d="M12.692,0A10.416,10.416,0,0,0,2.416,8.794H.33c-.293,0-.38.186-.195.412l2.613,3.174a.412.412,0,0,0,.669-.007L5.9,9.213c.181-.23.089-.419-.2-.419H3.881a8.957,8.957,0,1,1,9.25,10.552v0a8.937,8.937,0,0,1-6.774-2.608.721.721,0,0,0-1.021,1.019,10.367,10.367,0,0,0,7.288,3.04c.022,0,.043.007.067.007a10.4,10.4,0,1,0,0-20.8Z" transform="translate(-0.038)"/>
          </g>
        </g>
      </svg>

    );
  }
}

Edit.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default Edit;



/** WEBPACK FOOTER **
 ** ./src/icons/Edit/index.js
 **/